import { useTranslation } from 'react-i18next';

import { Badge } from '@nucleus-commerce/ui/components/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@nucleus-commerce/ui/components/tooltip';
import { cn } from '@nucleus-commerce/ui/lib/utils';

/** Set by a completed do_not_sell privacy request; staff cannot clear it from the admin. */
export function DoNotSellBadge({ className }: { className?: string }) {
  const { t } = useTranslation('customers');
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          tabIndex={0}
          aria-description={t('doNotSell.description')}
          className={cn('bg-warning/20 text-warning-foreground border-transparent', className)}
        >
          {t('doNotSell.label')}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{t('doNotSell.description')}</TooltipContent>
    </Tooltip>
  );
}
